import { animate } from 'framer-motion'
import { FC, useEffect, useRef, useState } from 'react'

interface AnimatedNumberProps {
  value: number
  formatValue?: (value: number) => string
}

/* Anima el valor como contador (cuenta desde el último valor mostrado, o desde 0 la primera vez)
   en vez de saltar directo al número final. Usa la API imperativa `animate` de framer-motion
   sobre un número plano (no un elemento del DOM), así sirve tanto para enteros como para montos
   ya formateados vía `formatValue`. */
const AnimatedNumber: FC<AnimatedNumberProps> = ({ value, formatValue }) => {
  const [display, setDisplay] = useState(0)
  const prevValue = useRef(0)

  useEffect(() => {
    const controls = animate(prevValue.current, value, {
      duration: 0.9,
      ease: 'easeOut',
      onUpdate: (v) => setDisplay(v)
    })
    prevValue.current = value
    return () => controls.stop()
  }, [value])

  const rounded = Math.round(display)
  return <>{formatValue ? formatValue(rounded) : rounded.toLocaleString('es-CL')}</>
}

export default AnimatedNumber
